
import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";
import { dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import AddDetails from "./verifyVendorDetails/AddDetails";
import WizardTopHeader from "./topHeader/WizardTopHeader";
import StudentMappedDetailsPage from "./paymentDetails/StudentMappedDetailsPage";
import ReviewStep from "./sendForApproval/ReviewStep";
import PaymentApproval from "../../../vendorManagement/admission-advisor-dashboard/PaymentApproval";
import PaymentApprovalWithActions from "./PaymentApprovalWithActions";

export const getDropdowns = async () => {
    const dropdown = await Promise.all([
        // dropdownMapping(endpoint?.term?.getAllActive, "termDispValue", "id"),

        // dropdownMapping(
        //   endpoint.academic_career.getAllActive,
        //   "academicCareerDispValue",
        //   "id"
        // ),
        dropdownMapping(
            endpoint.businessArea.getAllActiveV2,
            "businessAreaDispValue",
            "id",
            "businessAreaDesc",
            "sapPlantId"
        ),
        dropdownMapping(
            endpoint.courseCatelogMapping.getAllActiveCourseIds,
            "courseIds"
        ),
        dropdownMapping(
            endpoint.programAction.getAllActive,
            "programActionKey",
            "programActionKey",
        ),
        // dropdownMapping(
        //     endpoint.businessUnitType.getAllBusinessUnitType,
        //     "businessUnitTypeDispValue",
        //     "id",
        // ),
        dropdownMapping(
            endpoint.academic_year.getAllActive,
            "academicYearDisplayValue",
            "id",
        ),
        dropdownMapping(
            endpoint.academic_group.getAllActive,
            "academicGroupDispValue",
            "id"
        ),
        fetchAllPostPromisedData(
            `${endpoint.vendorManagement.search}?offset=-1`,
            {}
        ),
        dropdownMapping(
            endpoint.country.getAllActive,
            "countryDesc",
            "countryCode",
        ),
        fetchAllPostPromisedData(
            `${endpoint.bankMaster.search}?offset=-1`,
            {}
        )
    ]);
    const vendorList = dropdown[5]?.data?.vendorDataList || [];
    const bankList = dropdown[7]?.data?.bankMasterList ?? [];
    return {
        businessAreas: dropdown[0],
        courseIds: dropdown[1],
        programActions: dropdown[2],
        year: dropdown[3],
        streams: dropdown[4],
        allVendors: vendorList.map(v => ({ ...v, label: v?.vendorSapCode, value: v?.id })),
        allCountries: dropdown[6],
        allBanks: bankList?.map(bank => ({ ...bank, label: bank?.bankName, value: bank?.id, bankId: bank?.bankId })),
        // allVendors: vendorList
        // term: dropdown[0],

        // branchTypes: dropdown[4],
    };
};

const vendorRequestSteps = [
    {
        id: "verifyVendorDetails",
        label: "Verify vendor details",
        component: AddDetails,
    },
    {
        id: "paymentDetails",
        label: "Payment details",
        component: StudentMappedDetailsPage,
    },
    {
        id: "sendForApproval",
        label: "Send for approval",
        component: ReviewStep,
    },
];

export const defaultStreamValues = {
    list: [],
    loading: false,
    hasData: false,
    totalAmount: 0,
    paginationInfo: {
        currentPage: 0,
        totalRecords: 0,
        totalPage: 0,
        pageSize: 10
    }
};

export const vendorConfigInitialValues = {
    vendorType: "NA",
    vendorDetailsLoading: false,
    vendorDetails: {},
    addVendorForm: {},
    paymentMappingsLoading: false,
    SOE: { ...defaultStreamValues },
    SOM: { ...defaultStreamValues },
    SOF: { ...defaultStreamValues },
}

export const vendorRequestWizardConfig = {
    resource: "users",
    searchWizard: {
        isShow: true,
        component: PaymentApprovalWithActions
    },
    fetchDropdown: getDropdowns,
    initialValues: vendorConfigInitialValues,
    steps: vendorRequestSteps,
    topHeader: WizardTopHeader
};